// src/pages/ShippingPage.jsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function ShippingPage() {
  const navigate = useNavigate();

  return (
    <div className="sh-root">
      <style dangerouslySetInnerHTML={{ __html: STYLES }} />

      {/* HERO */}
      <section className="sh-hero">
        <button className="sh-back" onClick={() => navigate(-1)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
          </svg>
          Back
        </button>
        <div className="sh-badge">Shipping</div>
        <h1>Shipping <span className="grad">Info</span></h1>
        <p className="sh-lede">
          Fast, tracked delivery from our verified sellers worldwide.
        </p>
      </section>

      {/* RATES TABLE */}
      <section className="sh-section">
        <div className="sh-section-inner">
          <div className="sh-section-label">Delivery Times & Rates</div>
          <h2>Shipping <span className="grad">Options</span></h2>
          <p>Rates and timing vary by seller. Exact costs are calculated at checkout based on your address.</p>

          <div className="sh-table-wrap">
            <table className="sh-table">
              <thead>
                <tr>
                  <th>Region</th>
                  <th>Standard</th>
                  <th>Express</th>
                  <th>Free shipping threshold</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><span className="sh-flag">🇺🇸</span> United States</td>
                  <td>3–5 business days</td>
                  <td>1–2 business days</td>
                  <td>$75+</td>
                </tr>
                <tr>
                  <td><span className="sh-flag">🇻🇳</span> Vietnam</td>
                  <td>2–4 business days</td>
                  <td>1 business day</td>
                  <td>500,000 VND+</td>
                </tr>
                <tr>
                  <td><span className="sh-flag">🇬🇧</span> United Kingdom</td>
                  <td>5–7 business days</td>
                  <td>2–3 business days</td>
                  <td>£60+</td>
                </tr>
                <tr>
                  <td><span className="sh-flag">🇪🇺</span> European Union</td>
                  <td>5–10 business days</td>
                  <td>3–5 business days</td>
                  <td>€70+</td>
                </tr>
                <tr>
                  <td><span className="sh-flag">🌏</span> Asia Pacific</td>
                  <td>7–14 business days</td>
                  <td>3–5 business days</td>
                  <td>Varies by country</td>
                </tr>
                <tr>
                  <td><span className="sh-flag">🌍</span> Rest of world</td>
                  <td>10–21 business days</td>
                  <td>5–10 business days</td>
                  <td>Varies by country</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* KEY FACTS */}
      <section className="sh-section sh-section-alt">
        <div className="sh-section-inner">
          <div className="sh-section-label">What to Expect</div>
          <h2>Clear, Tracked, <span className="grad">Reliable</span></h2>

          <div className="sh-facts">
            <div className="sh-fact">
              <div className="sh-fact-icon">📦</div>
              <h3>Processing time</h3>
              <p>Orders are typically prepared and shipped within 1–2 business days of payment.</p>
            </div>
            <div className="sh-fact">
              <div className="sh-fact-icon">🔍</div>
              <h3>Tracking included</h3>
              <p>Every order comes with a tracking number. You'll get email updates at each stage.</p>
            </div>
            <div className="sh-fact">
              <div className="sh-fact-icon">🌐</div>
              <h3>International orders</h3>
              <p>Customs fees and import duties are the buyer's responsibility. Check your country's rules before ordering.</p>
            </div>
            <div className="sh-fact">
              <div className="sh-fact-icon">✅</div>
              <h3>Signature on delivery</h3>
              <p>High-value items may require a signature. You'll be notified if this applies to your order.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CARRIERS */}
      <section className="sh-section">
        <div className="sh-section-inner">
          <div className="sh-section-label">Trusted Carriers</div>
          <h2>Shipped with <span className="grad">Partners You Know</span></h2>
          <p>Depending on the seller and destination, your order may ship with one of these carriers:</p>
          <div className="sh-carriers">
            {["USPS", "UPS", "FedEx", "DHL", "Vietnam Post", "GHN", "SF Express", "Royal Mail"].map(c => (
              <div key={c} className="sh-carrier">{c}</div>
            ))}
          </div>
        </div>
      </section>

      {/* QUESTIONS */}
      <section className="sh-contact">
        <h2>Shipping questions?</h2>
        <p>We'll help you track, route, or resolve any delivery issue.</p>
        <div className="sh-contact-btns">
          <a href="mailto:shipping@jeptags.com" className="sh-btn-primary">Email Shipping Team</a>
          <Link to="/help" className="sh-btn-secondary">Visit Help Center</Link>
        </div>
      </section>
    </div>
  );
}

const STYLES = `
.sh-root *,.sh-root *::before,.sh-root *::after{margin:0;padding:0;box-sizing:border-box}
.sh-root{
  --cyan:#00E5CC;--cyan-bright:#00FFE0;--teal:#22D97F;
  --navy-deep:#030a14;--navy:#0a1628;--navy-mid:#0F2140;
  font-family:'Sora',sans-serif;background:var(--navy-deep);color:#e0f0f0;min-height:100vh;
}
.sh-root a{color:var(--cyan);text-decoration:none}
.grad{background:linear-gradient(135deg,var(--cyan-bright),var(--cyan),var(--teal));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}

/* HERO */
.sh-hero{max-width:860px;margin:0 auto;padding:60px 24px 40px;text-align:center;position:relative}
.sh-back{position:absolute;top:60px;left:24px;display:inline-flex;align-items:center;gap:6px;background:none;border:1px solid rgba(0,229,204,0.15);color:rgba(224,240,240,0.6);font-family:'Sora',sans-serif;font-size:13px;padding:8px 16px;border-radius:8px;cursor:pointer;transition:all .3s}
.sh-back:hover{border-color:var(--cyan);color:var(--cyan)}
.sh-back svg{width:14px;height:14px}
.sh-badge{display:inline-block;padding:8px 20px;border-radius:100px;background:rgba(0,229,204,0.08);border:1px solid rgba(0,229,204,0.15);font-size:12px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:var(--cyan);margin-bottom:20px}
.sh-hero h1{font-size:clamp(36px,5vw,52px);font-weight:800;line-height:1.1;letter-spacing:-1.5px;margin-bottom:14px}
.sh-lede{font-size:17px;color:rgba(224,240,240,0.55);max-width:560px;margin:0 auto;line-height:1.7}

/* SECTION */
.sh-section{padding:48px 24px}
.sh-section-alt{background:rgba(15,33,64,0.3)}
.sh-section-inner{max-width:960px;margin:0 auto}
.sh-section-label{display:inline-block;padding:6px 14px;border-radius:100px;background:rgba(0,229,204,0.06);border:1px solid rgba(0,229,204,0.12);font-size:11px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:var(--cyan);margin-bottom:16px}
.sh-section h2{font-size:clamp(26px,4vw,36px);font-weight:800;line-height:1.2;letter-spacing:-.8px;margin-bottom:20px}
.sh-section p{font-size:16px;line-height:1.75;color:rgba(224,240,240,0.6);margin-bottom:16px;max-width:720px}

/* TABLE */
.sh-table-wrap{margin-top:24px;overflow-x:auto;background:rgba(15,33,64,0.5);border:1px solid rgba(0,229,204,0.08);border-radius:16px}
.sh-table{width:100%;border-collapse:collapse;min-width:600px}
.sh-table th{padding:14px 18px;text-align:left;font-size:11px;font-weight:700;letter-spacing:.8px;text-transform:uppercase;color:var(--cyan);border-bottom:1px solid rgba(0,229,204,0.1);background:rgba(0,229,204,0.04)}
.sh-table td{padding:16px 18px;font-size:14px;color:rgba(224,240,240,0.65);border-bottom:1px solid rgba(0,229,204,0.06)}
.sh-table tr:last-child td{border-bottom:none}
.sh-table tr:hover td{background:rgba(0,229,204,0.02)}
.sh-flag{margin-right:8px}

/* FACTS */
.sh-facts{display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-top:28px}
.sh-fact{padding:24px;background:rgba(3,10,20,0.5);border:1px solid rgba(0,229,204,0.06);border-radius:16px}
.sh-fact-icon{font-size:28px;margin-bottom:12px}
.sh-fact h3{font-size:16px;font-weight:700;color:#e0f0f0;margin-bottom:8px}
.sh-fact p{font-size:14px;line-height:1.65;color:rgba(224,240,240,0.55);margin:0}

/* CARRIERS */
.sh-carriers{display:flex;flex-wrap:wrap;gap:10px;margin-top:24px}
.sh-carrier{padding:10px 20px;border-radius:10px;background:rgba(15,33,64,0.5);border:1px solid rgba(0,229,204,0.1);color:rgba(224,240,240,0.65);font-size:14px;font-weight:600}

/* BUTTONS */
.sh-btn-primary{display:inline-block;padding:14px 28px;border-radius:12px;background:linear-gradient(135deg,var(--cyan-bright),var(--teal));color:var(--navy-deep);font-weight:700;font-size:15px;transition:transform .25s}
.sh-btn-primary:hover{transform:translateY(-2px)}
.sh-btn-secondary{display:inline-block;padding:14px 28px;border-radius:12px;border:1px solid rgba(0,229,204,0.25);background:transparent;color:var(--cyan);font-weight:600;font-size:15px;transition:all .25s}
.sh-btn-secondary:hover{border-color:var(--cyan);background:rgba(0,229,204,0.04)}

/* CONTACT */
.sh-contact{max-width:860px;margin:0 auto;padding:40px 24px 100px;text-align:center}
.sh-contact h2{font-size:26px;font-weight:800;letter-spacing:-.5px;margin-bottom:10px}
.sh-contact p{font-size:15px;color:rgba(224,240,240,0.5);margin-bottom:24px}
.sh-contact-btns{display:flex;gap:12px;justify-content:center;flex-wrap:wrap}

@media(max-width:700px){
  .sh-back{position:static;margin-bottom:20px}
  .sh-hero{padding:40px 20px 32px}
  .sh-facts{grid-template-columns:1fr}
}
`;
